import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-views-nomenu',
  templateUrl: './views-nomenu.component.html',
})
export class ViewsNomenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
